import React from "react";
import PlansBTableContainer from "Containers/PlansBTableContainer";
import Container from "reactstrap/lib/Container";
import { PaddingBottom } from "ComponentsUI/Spacings";

export default class extends React.Component {
    render() {
        return (
            <PaddingBottom>
                <Container>
                    <PlansBTableContainer
                        showNames={true}
                        tariffs={this.props.tariffs}
                        pagination={this.props.pagination}
                        urlDefault={this.props.urlDefault}
                        isRates={this.props.isRates}
                        pageName="tariffs_prov"
                        microMarkupProduct={this.props.microMarkupProduct}
                        update_date={this.props.update_date}
                    />
                </Container>
            </PaddingBottom>
        );
    }
}
